import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProductCategoriesForSpecies} from "../../models/product-categories-for-species.model";
import {ProductCategory} from "../../models/product-category.model";
import {PartnerProduct} from "../../models/partner-product.model";
import {Subscription} from "rxjs";
import {IonSearchbar} from "@ionic/angular";

@Component({
  selector: 'app-partner-product-categories-filter',
  templateUrl: './partner-product-categories-filter.component.html',
  styleUrls: ['./partner-product-categories-filter.component.scss'],
})
export class PartnerProductCategoriesFilterComponent implements OnInit {

  @Input()
  mainCategories: ProductCategoriesForSpecies[];
  categories: ProductCategory[];
  subCategories: ProductCategory[];


  activeSpecies: string;
  activeCategory: string;
  activeSubCategory: any;
  @Input()
  nameToFind: string;
  @Input()
  products: PartnerProduct[];

  isBusySub: Subscription;

  items: PartnerProduct[];
  catProducts: PartnerProduct[];
  @ViewChild('search') search: IonSearchbar;


  private isBusy: boolean;
  isLoading: boolean = false;

  @Output() addProductEmitter = new EventEmitter<PartnerProduct>();


  constructor() {
  }

  ngOnInit() {
    this.catProducts = this.products;
    this.speciesChanges('DOG');  //set default value
  }

  speciesChanges(value: string) {
    this.activeSpecies = value;
    this.activeCategory = null;
    this.activeSubCategory = null;

    this.items = this.products;
    this.categories = this.mainCategories.filter(e => e.species === this.activeSpecies)[0].categories;
    if (this.activeSpecies === 'CAT') {
      this.items = this.items?.filter(item => item.categoriesJson?.includes('Dla kota'));
    }

    if (this.activeSpecies === 'DOG') {
      this.items = this.items?.filter(item => item.categoriesJson?.includes('Dla psa'));
    }

  }


  categoryChanges(category) {
    this.activeCategory = category.name;
    this.subCategories = this.categories.filter(e => e.name === this.activeCategory)[0].categories;
    this.items = this.products;
    this.items = this.items?.filter(item => item.categoriesJson?.includes(this.activeCategory));
  }


  subCategoryChanges(category) {
    this.activeSubCategory = category.name;
    this.items = this.products;
    this.items = this.items?.filter(item => item.categoriesJson?.includes(this.activeSubCategory));
  }

  onItemChosen(item: PartnerProduct) {
    this.addProductEmitter.emit(item);
  }


  getItemName(item) {
    return item.name;
  }

  getSelectedCategory() {
    return this.activeSubCategory ? this.activeSubCategory : (this.activeCategory ? this.activeCategory : this.activeSpecies ? (this.activeSpecies === 'CAT' ? 'Dla kota' : 'Dla psa') : null )
  }
}
